import React from "react";
import { theme } from "@avista/common-avista-material-ui-theme";
import { StyledEngineProvider, ThemeProvider, responsiveFontSizes } from "@mui/material";

const responsiveFontSizesTheme = responsiveFontSizes(theme);

export const MuiThemeProvider: React.FC<React.PropsWithChildren> = ({ children }) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={responsiveFontSizesTheme}>{children}</ThemeProvider>
  </StyledEngineProvider>
);
